import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="drawer--touched"
export default class extends Controller {
  static values = {
    identifier: String
  }

  click() {
    if (this.hasIdentifierValue) {
      this.dispatch("click", {detail: {identifier: this.identifierValue}})
    }
  }
}
